import LTR from "@brand-icons/ploom/tobacco-leaf/tobacco-leaf-ltr.svg";

import { iconFactory } from "../iconFactory";

export const TobaccoLeafIcon = iconFactory("TobaccoLeafIcon", LTR);
